<template>
  <div class="row">
    <div class="col-12">
      <card-filter
        @setupTable="setupTable"
        @filter="handleFilter"
        @showHideLoading="showHideLoading"
      />
      <card v-if="tableData.length > 0">
        <br />
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-1"
          ></card-header>
          <master-table
            :infoTable="queriedData"
            :columns="tableColumns"
            :objectSpanMethod="objectSpanMethod"
            :defaultSort="{ prop: 'worker_code', order: 'ascending' }"
            :showColumnStatus="false"
          />
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" :propPagination="pagination" />
        <div class="mt-3">
          <div class="align-exportable">
            <div class="px-3" v-if="isPDF()">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportToPDFHeader"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
            <div class="px-3" v-if="isExcel()">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportXLSHeader()"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
        <br />
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Pagination as LPagination } from 'src/components/index';
import CardFilter from './CardFilter.vue';
import configTable from './segregated-operators-table';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import MixinExportSegregated from './mixin-export-segregated';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import MixinGroupData from './mixin-group-data';

export default {
  components: {
    [CardFilter.name]: CardFilter,
    LPagination,
  },
  data() {
    return {
      dataFilter: {},
      model: null,
      reportType: 0,
      tableColumns: [],
      rowspanInfo: {},
    };
  },
  mixins: [
    MixinMasters,
    MixinMenu,
    MixinPermissions,
    MixinExportSegregated,
    MixinGroupData,
  ],
  watch: {
    '$i18n.locale': ['setupTable'],
  },
  computed: {
    calculateSpanPagination() {
      return this.preprocessDataPagination(
        this.queriedData,
        ['worker_code', 'farm_name', 'payment_period_name'],
        'rowSpanPagination'
      );
    },
  },
  methods: {
    objectSpanMethod({ rowIndex, columnIndex }) {
      this.calculateSpanPagination;
      const isBananitas = this.$store.state.auth.user.business.some(
        (item) => item.id === 206
      );
      if (isBananitas) {
        if (columnIndex <= 2) {
          if (this.rowSpanPagination[rowIndex]) {
            const span = Math.min(
              this.rowSpanPagination[rowIndex],
              this.pagination.perPage - rowIndex
            );

            return {
              rowspan: span,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        } else if (columnIndex === 3) {
          if (this.rowSpanPagination[rowIndex]) {
            const span = Math.min(
              this.rowSpanPagination[rowIndex],
              this.pagination.perPage - rowIndex
            );
            return {
              rowspan: span,
              colspan: 1,
              cellClassName: 'font-weight-bold',
              cellStyle: { backgroundColor: '#f5f5f5' },
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      } else {
        if (columnIndex <= 3) {
          if (this.rowSpanPagination[rowIndex]) {
            const span = Math.min(
              this.rowSpanPagination[rowIndex],
              this.pagination.perPage - rowIndex
            );

            return {
              rowspan: span,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        } else if (columnIndex === 4) {
          if (this.rowSpanPagination[rowIndex]) {
            const span = Math.min(
              this.rowSpanPagination[rowIndex],
              this.pagination.perPage - rowIndex
            );
            return {
              rowspan: span,
              colspan: 1,
              cellClassName: 'font-weight-bold',
              cellStyle: { backgroundColor: '#f5f5f5' },
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      }
    },
    handleFilter(data) {
      this.dataFilter = { ...this.dataFilter, ...data };
      this.getDataSamples();
    },
    getDataSamples() {
      this.showHideLoading(true);
      let data = this.dataFilter;
      data.route = 'works/segregatedbyoperators';
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = this.preprocessData(response.data.data.labor_data, [
            'worker_code',
            'farm_name',
            'payment_period_name',
          ]);
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('sweet_alert.jobs.unavailable_data'));
          } else {
            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns.map((prop) => {
                return prop.prop;
              }),
            });
            this.pagination.perPage = 50;
            this.pagination.currentPage = 1;
            this.searchQuery = '';
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table } = configTable();
      this.pagination = { ...Table.pagination };

      const isBananitas = this.$store.state.auth.user.business.some(
        (item) => item.id === 206
      );

      /**
       * Eliminar la columna 'total' si el criterio es verdadero
       * esto es una medida temporal
       */
      this.tableColumns = isBananitas
        ? Table.tableColumns.filter(
            (column) => column.prop !== 'payment_period_name'
          )
        : Table.tableColumns;

      this.pagination.perPage = 5;
      this.pagination.currentPage = 1;
    },
  },
  mounted() {
    this.selectedItemOnMenu('works/laborheader');
  },
  destroyed() {
    this.deselectedItemOnMenu('works/laborheader');
  },
};
</script>
